"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LazyLinks = void 0;
var _react = require("react");
var _hooks = require("../../../hooks");
var _Skeleton = require("../../Skeleton");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
} // istanbul ignore file -- lazy loaded component not testable
const LazyGeneratedBurgerMainMenuLinks = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "TopArea_Links" */'./Links'))));
const LazyLinks = () => {
  const isMobile = (0, _hooks.useIsMobile)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: isMobile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.SkeletonMainCategoriesMobile, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.SkeletonMainCategoriesDesktop, {}),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(LazyGeneratedBurgerMainMenuLinks, {})
  });
};
exports.LazyLinks = LazyLinks;
var _default = exports.default = LazyLinks;